import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=6e24b47a"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e24b47a')) {
      api.createRecord('6e24b47a', component.options)
    } else {
      api.reload('6e24b47a', component.options)
    }
    module.hot.accept("./matrix.vue?vue&type=template&id=6e24b47a", function () {
      api.rerender('6e24b47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/matrix.vue"
export default component.exports